<template>
  <div class="materialShare-container" v-if="showModel">
    <article class="case-details">
      <div class="webesite-swip" v-if="swipeList.length>0">
        <van-swipe class="my-swipe" :autoplay="3000" @change="onSwipeChange" lazy-render>
          <van-swipe-item
              v-for="item in swipeList"
              :key="item"
          >
            <img :src="item" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator"><span>{{ current + 1 }}</span>/{{ swipeList.length }}</div>
          </template>
        </van-swipe>
      </div>

     <div class="box_container">
       <div class="title">
         {{ oneCase.materialName }}&nbsp;&nbsp;<span>{{ oneCase.itemNo }}</span>
       </div>
       <span class="brand_name">
        {{oneCase.brandName }}
       </span>
       <div v-if="oneCase.packageName">
         <span class="package">
           {{ oneCase.packageName }}
         </span>
       </div>
       <div class="sale_price">
         销售价：<span>¥{{ oneCase.sellingPrice }}</span>/<span>{{ oneCase.salesUnitName }}</span>
       </div>
     </div>
      <van-sticky>
        <van-skeleton title avatar :row="3" v-if="showSkeleton"></van-skeleton>
        <div v-else class="card-box-cls">
          <div class="card-box">
            <div class="card-info" @click="handleViewUserCard">
              <div class="card-left">
                <img
                    :src="
                    oneCase.userCard.headImgUrl
                      ? `${imgUrl}/${oneCase.userCard.headImgUrl}`
                      : morenHeadImg
                  "
                    alt=""
                />
                <!-- <img src="../../assets/icons/mimi.jpg" alt=""> -->
                <div class="creater-info">
                  <div class="title">{{ oneCase.userCard.name }}</div>
                  <div class="second">
                    {{ oneCase.userCard.impressionLabel }}
                  </div>
                </div>
              </div>
              <div class="card-right" @click.stop="handleCall">
                <!-- <svg class="phone">
                    <use xlink:href="/phone.svg#phone-contract"></use>
                    </svg> -->
                <div class="phone">电话联系</div>
              </div>
            </div>
            <div class="synopsis">
              <span>{{ isFold ? foldSynopsisStr : synopsisStr }}</span>
              <span
                  style="color: #999"
                  @click="handleIsFold"
                  v-if="synopsisStr.length > 40"
              >{{ isFold ? "...展开" : "&lt;&lt;折叠" }}</span
              >
            </div>
          </div>
        </div>
      </van-sticky>
      <div class="division_cls"></div>
      <div class="case-design">
        <div class="model_cls">
          <div class="model_cls_title">基本信息</div>
          <div class="model_cls_key_val">
            <span class="model_cls_key">分类</span>
            <span class="model_cls_val">{{ oneCase.categoryName }}</span>
          </div>
          <div class="van-hairline--bottom"></div>
          <div class="model_cls_key_val">
            <span class="model_cls_key">规格</span>
            <span class="model_cls_val">{{ oneCase.specs }}</span>
          </div>
          <div class="van-hairline--bottom"></div>
          <div class="model_cls_key_val">
            <span class="model_cls_key">采购单位</span>
            <span class="model_cls_val">{{ oneCase.purchasingUnitName }}</span>
          </div>
          <div class="van-hairline--bottom"></div>
          <div class="model_cls_key_val">
            <span class="model_cls_key">换算率</span>
            <span class="model_cls_val">{{oneCase.conversionRate}}</span>
          </div>
          <div class="van-hairline--bottom"></div>
          <div class="model_cls_key_val">
            <span class="model_cls_key">编码</span>
            <span class="model_cls_val">{{oneCase.materialCode}}</span>
          </div>
          <div class="van-hairline--bottom"></div>
        </div>
        <div class="division_cls"></div>
        <div class="model_cls">
          <div class="more_prop">
            <div >物料属性</div>
            <div @click="showMoreProp = true" style="display: flex;align-items: center">查看更多<van-icon name="arrow" /></div>
          </div>
          <div v-for="it in propertiesSlice" :key="it.propertyId">
            <div class="model_cls_key_val">
              <span class="model_cls_key">{{ it.propertyName }}</span>
              <span class="model_cls_val">{{ it.propertyValue }}</span>
            </div>
            <div class="van-hairline--bottom"></div>
          </div>

<!--          <div class="model_cls_key_val">-->
<!--            <span class="model_cls_key">{{ oneCase.properties[1].propertyName }}</span>-->
<!--            <span class="model_cls_val">{{ oneCase.properties[1].propertyValue }}</span>-->
<!--          </div>-->
<!--          <div class="van-hairline&#45;&#45;bottom"></div>-->
<!--          <div class="model_cls_key_val">-->
<!--            <span class="model_cls_key">{{ oneCase.properties[2].propertyName }}</span>-->
<!--            <span class="model_cls_val">{{ oneCase.properties[2].propertyValue }}</span>-->
<!--          </div>-->
<!--          <div class="van-hairline&#45;&#45;bottom"></div>-->
        </div>
        <div class="division_cls"></div>
        <div class="material_details">物料详情</div>
        <div class="case-content">
          <div class="case-content-box">
            <transform-html :contents="oneCase.details"></transform-html>
          </div>
        </div>
      </div>
      <!--    更多属性-->
      <van-popup v-model:show="showMoreProp" safe-area-inset-bottom  round position="bottom" :style="{ height: '50%',overflow: 'hidden' }" >
        <van-nav-bar
            title="物料属性"
        >
        </van-nav-bar>
          <div style="height:72%; overflow-x: hidden;">
            <div class="case-design">
              <div class="model_cls">
                <div v-for="it in oneCase.properties" :key="it.propertyId">
                  <div class="model_cls_key_val">
                    <span class="model_cls_key">{{ it.propertyName }}</span>
                    <span class="model_cls_val">{{ it.propertyValue }}</span>
                  </div>
                  <div class="van-hairline--bottom"></div>
                </div>
              </div>
            </div>
          </div>
        <div class="footer_button">
          <van-button round type="primary" @click="showMoreProp = false" size="large" text="关闭"/>
        </div>
      </van-popup>
    </article>
    <footer class="huoke-footer">
      <div class="article_list_buttom2">
        <van-tabbar v-model="active" active-color="#646566" @change="onChange">
          <van-tabbar-item>
            <icon-svg iconClass="iconsmartphone1" class="zixun" />
            <span>电话联系</span>
          </van-tabbar-item>
          <van-tabbar-item>
            <icon-svg iconClass="iconmessage-square" class="zixun" />
            <span>我要咨询</span>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </footer>
    <!-- 咨询 -->
    <div class="consulting">
      <van-overlay :show="showConsulting" @click="showConsulting = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <p class="title">我要咨询</p>
            <van-form ref="addInfoForm" error-message-align="right">
              <div class="info">
                <van-field
                    v-model="addInfo.username"
                    label="姓名"
                    :rules="[{ required: true, message: '请输入名称' }]"
                />
                <van-field
                    v-model="addInfo.phone"
                    label="手机号"
                    type="tel"
                    :rules="[
                    {
                      required: true,
                      pattern: /^1[3|4|5|7|8]\d{9}$/,
                      message: '无效手机号',
                    },
                  ]"
                />
                <van-field
                    v-model="addInfo.content"
                    label="留言"
                    type="textarea"
                    :rules="[{ required: true, message: '请输入留言' }]"
                />
              </div>
            </van-form>
            <van-grid clickable :column-num="2">
              <van-grid-item text="返回" @click="handlecomback" />
              <van-grid-item text="保存" @click="handleAddInfo" />
            </van-grid>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, toRefs, onUnmounted, ref } from "vue";
import { Dialog, Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import { createCaseConsult, addNum } from "../../api/case";
import {addClueBehaviorInfo} from "@/api/user/clue"
import { useWxAuthorization } from "@/hooks/wxAuthorization";
import transformHtml from "../../components/transformHTML.vue";
import $ from "jquery";
import { initWechatShare } from "../../hooks/initWechatShare";
import {addClue} from "../../api/user/clue";
import {getMaterial} from "../../api/user/index";
export default {
  components: {
    transformHtml,
  },
  setup() {
    let internal = null;
    let seconds = 0;
    const route = useRoute();
    const router = useRouter();
    let addInfoForm = ref(null);
    const merchantId = route.params.merchantId;
    const recommendClueId = route.params.recommendClueId?route.params.recommendClueId:''
    const state = reactive({
      propertiesSlice:[],
      showMoreProp:false,
      current: 0,
      swipeList: [],
      showSkeleton:true,
      showModel: true,
      morenHeadImg: require("../../assets/icons/Vector.png"),
      active: null,
      showConsulting: false,
      loading: false,
      imgUrl: process.env.VUE_APP_WATCH_FILE_API,
      loadingCase: false,
      showShare: false,
      materialId: route.params.id,
      consultId: null,
      openId: null,
      oneCase: {},
      icon: {
        inactive: require("../../assets/icons/smartphone.png"),
        active: require("../../assets/icons/smartphone.png"),
        mycaseN: require("../../assets/icons/wechat-chat.png"),
        mycaseC: require("../../assets/icons/wechat-chat.png"),
        consult: require("../../assets/icons/message-square.png"),
      },
      addInfo: {
        username: "",
        phone: "",
        content: "",
        busiId: route.params.id,
      },
      synopsisStr: "",
      foldSynopsisStr: "",
      isFold: true,
      clueId: "",
    });
    const onSwipeChange = (index)=> {
      state.current = index;
    };
    const onChange = (index) => {
      if (index === 0) {
        handleCall();
        state.active = null;
      }
      if (index === 1) {
        state.showConsulting = true;
      }
    };
    const handlecomback = () => {
      state.showConsulting = false;
      state.active = null;
      state.addInfo.content = "";
    };
    const handleAddInfo = () => {
      state.active = null;
      let param = {
        ...state.addInfo,
      };
      addInfoForm.value.validate().then(() => {
        createCaseConsult(param).then((data) => {
          if (data) {
            state.consultId = data.id;
            // Dialog.alert({ title: "成功", message: "您的咨询已创建" });
            Toast.success("您的咨询已创建");
            countUserAction({clueId:state.clueId,openId:state.openId,type:5})
            state.showConsulting = false;
          }
        });
      });
    };
    const loadMaterialDetails = async () => {
      let result = await getMaterial(state.materialId)
      state.oneCase = result;
      state.swipeList = []
      if (result.properties.length>0){
        state.propertiesSlice = result.properties.slice(0,3)
      }
      if(result.rotationPicture.length>0){
        state.swipeList = result.rotationPicture.map(it=>{
          return `${process.env.VUE_APP_WATCH_FILE_API}/${it}`;
        })
      }
      state.loadingCase = true;
      state.synopsisStr = result.userCard.selfIntro?result.userCard.selfIntro:'我坚信细节决定品质，专业决定价值！如有需求，请随时与我联系！';
      state.foldSynopsisStr = state.synopsisStr.substring(0, 44);
      state.showSkeleton = false

    };
    //展开折叠
    //展开折叠
    const handleIsFold = () => {
      state.isFold = !state.isFold;
    };
    const useWxAuth = async ()=>{
      let data= await  useWxAuthorization()
      if (data) {
        state.openId = data.openId;
      } else {
        state.openId = route.query.openId;
      }
      // await loadMaterialDetails();

      if (state.openId) {
        await loadMaterialDetails();
        await handleFirstAddClue()
        let temp = location.href.split("?")[0];
        if(recommendClueId){
          temp =temp.replace(recommendClueId,state.clueId)
        }else {
          temp = `${temp}/${state.clueId}`
        }
        countUserAction({clueId:state.clueId,openId:state.openId,type:1})
        let shareImg;
        if (state.oneCase.picUrl) {
          shareImg = `${process.env.VUE_APP_WATCH_FILE_API}/${state.oneCase.picUrl}`;
        } else {
          shareImg = "https://wca.ujiaku.com/upload/app_defaultImg/material_img.png";
        }

        // eslint-disable-next-line no-undef
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.postMessage({
              data: {
                title: `${state.oneCase.userCard.name}为您推荐：${state.oneCase.materialName}`,
                img: shareImg,
                openId: state.openId,
                clueId: state.clueId,
                shareUrl:temp,
                type: 4
              },
            });
          } else {
            let title = `${state.oneCase.userCard.name}为您推荐：${state.oneCase.materialName}`;
            let desc = state.oneCase.materialName;
            let appPhone;
            if (localStorage.getItem("appPhone")) {
              appPhone = localStorage.getItem("appPhone")
            } else {
              appPhone = route.query.appPhone
            }
            let url = `${
                process.env.VUE_APP_WECHAT_SHARE
            }/shareForward?shareUrl=${temp}?appPhone=${appPhone}`;
            let imgUrl = shareImg;
            initWechatShare({ title, desc, url, imgUrl,openId:state.openId,clueId:state.clueId,type:4 });
          }
        });
      }
    }
    // useWxAuthorization().then((data) => {
    //   if (data) {
    //     state.openId = data.openId;
    //   } else {
    //     state.openId = route.query.openId;
    //   }
    //   if (state.openId) {
    //     handleFirstAddClue().then(()=>{
    //       countUserAction({clueId:state.clueId,openId:state.openId,type:1})
    //     })
    //   }
    // });
    //电话
    const handleCall = () => {
      if (state.oneCase.userCard.contactNum) {
        let a = document.createElement("a");
        a.setAttribute("href", `tel:${state.oneCase.userCard.contactNum}`);
        a.click();
        countUserAction({clueId:state.clueId,openId:state.openId,type:2})
      } else {
        Dialog.alert({ title: "错误", message: "没有电话号码" });
      }
    };
    const handleFirstAddClue = async () => {
      let miniProgramPhone = route.query.state
          ? route.query.state
          : route.query.miniProgramPhone;
      let param = {
        shareId: state.materialId,
        clueSource: 8,//8线索来源为物料
        browseSecond: 0,//浏览秒数
        beSharePhone: miniProgramPhone,//被分享人手机号 (Base64加密)
        openId: state.openId,//用户的openId
        title: state.oneCase.materialName,//分享标题
        createId: state.oneCase.loginUserId,//分享人ID
        consultId: state.consultId,//留资ID
        clueShareSource: route.params.clueShareSource,
        recommend_Clue_Id:recommendClueId,//推荐人ID
        merchantId//商家ID (前端传递)
      };
      let data = await addClue(param);
      state.clueId = data;
      return data;
    };
    const handleViewUserCard = () => {
      let miniProgramPhone = route.query.state
          ? route.query.state
          : route.query.miniProgramPhone;
      router.push({
        path: `/wxShareUserCard/${route.params.clueShareSource}/${merchantId}/${recommendClueId}`,
        query: { miniProgramPhone: miniProgramPhone, openId: state.openId },
      });
    };
    const handleAddClue = () => {
      if (seconds > 0) {
        let miniProgramPhone = route.query.state
            ? route.query.state
            : route.query.miniProgramPhone;
        let param = {
          clueId: state.clueId,
          browseSecond: seconds,
          consultId: state.consultId,
          shareId: state.materialId,
          clueSource: 8,
          beSharePhone: miniProgramPhone,
          openId: state.openId,
          title: state.oneCase.materialName,
          createId: state.oneCase.loginUserId,
          clueShareSource: route.params.clueShareSource,
          recommend_Clue_Id:recommendClueId,
          merchantId
        };
        $.ajax({
          async: false,
          url: `${process.env.VUE_APP_BASE_API}/user/clue/addClue`,
          type: "post",
          contentType: "application/json;charset=UTF-8",
          data: JSON.stringify(param),
        });
        seconds = 0;
        clearInterval(internal);
      }
    };
    const handleWindowHide = () => {
      if (seconds > 0) {
        let miniProgramPhone = route.query.state
            ? route.query.state
            : route.query.miniProgramPhone;
        let param = {
          clueId: state.clueId,
          browseSecond: seconds,
          consultId: state.consultId,
          shareId: state.materialId,
          clueSource: 8,
          beSharePhone: miniProgramPhone,
          openId: state.openId,
          title: state.oneCase.materialName,
          createId: state.oneCase.loginUserId,
          clueShareSource: route.params.clueShareSource,
          recommend_Clue_Id:recommendClueId,
          merchantId
        };
        let blob = new Blob([JSON.stringify(param)], {
          type: "application/json",
        });
        navigator.sendBeacon(
            `${process.env.VUE_APP_BASE_API}/user/clue/addClue`,
            blob
        );
        seconds = 0;
        clearInterval(internal);
      }
    };
    const handleVisibilityStateChange = () => {
      if (document.visibilityState === "hidden") {
        handleAddClue();
        clearInterval(internal);
        seconds = 0;
      }
    };
    const countUserAction = async ({ clueId, openId, type }) => {
      /**
       * type:
       *  1查看
       *  2拨打
       *  3保存
       *  4转发
       *  5提交咨询
       *  6点赞
       *  7收藏
       *  8留言
       */

      if (clueId) {
        await addClueBehaviorInfo({ clueId, openId, type });
      }
    };
    onMounted(() => {
      addNum(route.params.id, "views");
      // loadHotArticle();
      internal = setInterval(() => {
        seconds++;
      }, 1000);
      document.addEventListener(
          "visibilitychange",
          handleVisibilityStateChange
      );
      window.addEventListener("pagehide", handleWindowHide, false);
    });
    onUnmounted(() => {
      clearInterval(internal);
      handleAddClue();
      document.removeEventListener(
          "visibilitychange",
          handleVisibilityStateChange
      );
      window.removeEventListener("pagehide", handleWindowHide, false);
    });
    useWxAuth()
    return {
      ...toRefs(state),
      handleIsFold,
      addInfoForm,
      onChange,
      handlecomback,
      handleAddInfo,
      handleCall,
      handleViewUserCard,
      onSwipeChange,
    };
  },
};
</script>
<style lang="scss">
.panoramic-containei {
  position: relative;
  ::-webkit-scrollbar {
    display: none;
  }
  .comback-box {
    position: absolute;
    height: 36px;
    width: 60px;
    line-height: 36px;
    text-align: center;
    left: 0;
    top: 100px;
    color: white;
    font-size: 14px;
    background: rgba(46, 46, 46, 0.5);
    border-radius: 0 20px 20px 0;
    opacity: 0.5;
  }
}
.box_container{
  padding: 8px 16px;
  text-align: left;
  .title{
    font-size: 16px;
    color: #333333;
    margin-bottom: 10px;
  }
  .package{
    font-size: 12px;
    padding: 2px 8px;
    color: #C97F4F;
    background-color: #FDE4D2;
  }
  .brand_name{
    font-size: 14px;
    color: #D0021B;
    padding: 2px 6px;
    border: 1px solid #D0021B;
  }
  .sale_price{
    font-size: 12px;
    color: #999999;
    padding-top: 10px;
    span:nth-child(1){
      color: #D0021B;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
.materialShare-container {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .case-details {
    flex: 1;
    overflow-x: hidden;
    color: rgba(0, 0, 0, 0.56);
    .webesite-swip {
      height: 300px;
      .my-swipe {
        height: 100%;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
            .custom-indicator {
              color: #FFFFFF;
              position: absolute;
              right: 20px;
              bottom: 5px;
              padding: 1px 8px;
              font-size: 14px;
              border-radius: 10px;
              background: rgba(0, 0, 0, 0.3);
              span{
                font-size: 16px;
              }
            }
      }
    }
    .card-box-cls {
      background-color: #fff;
      padding: 5px 16px 16px 16px;
    }
    .card-box {
      // margin: 5px 16px 16px 16px;
      padding: 12px;
      border-radius: 8px;
      text-align: left;
      background-color: #fff;
      box-shadow: 0px 5px 15px rgb(229, 229, 230);
      .synopsis {
        margin-top: 5px;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.84);
      }
      .card-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .card-left {
          display: flex;
          img {
            height: 40px;
            width: 40px;
            border-radius: 20px;
          }
          .creater-info {
            margin-left: 8px;
            .title {
              font-weight: bold;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.84);
              margin-bottom: 3px;
            }
            .second {
              font-weight: normal;
              font-size: 11px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .card-right {
          .phone {
            width: 80px;
            height: 30px;
            background-color: #289fff;
            font-size: 12px;
            color: white;
            text-align: center;
            line-height: 30px;
            border-radius: 5px;
          }
        }
      }
    }
    //.case-design{
    //  padding: 8px 16px;
    //}
    .footer_button{
      padding: 0 16px;
      .van-button--large{
        height: 35px;
      }
    }
    .division_cls{
      height: 5px;
      background-color: #f6f5f5;
    }
    .model_cls{
      font-size: 14px;
      color: #999999;
      text-align: left;
      padding: 8px 16px;
      .more_prop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 20px;
      }
      .model_cls_title{
        padding-bottom: 20px;
      }
      .model_cls_key_val{
        display: flex;
        align-items: center;
        padding: 5px 0;
        .model_cls_key{
          padding: 5px 0;
          display: block;
          width: 100px;
        }
        .model_cls_val{
          color: #333333;
        }
      }
    }
    .material_details{
      padding: 10px 0;
      text-align: center;
      color: #333333;
      font-size: 16px;
    }
    .case-content {
      padding: 8px 16px;
      width: 100%;
      font-size: 14px;
      text-align: left;
      box-sizing: border-box;
      background-color: #ffffff;
      .case-content-box {
        p {
          margin: 0;
          padding: 0;
          font-size: 14px;
          font-weight: 400;
        }
        border-bottom: 1px solid #f1f3f6;
      }
    }
  }
  .huoke-footer {
    position: relative;
    height: 50px;
    .add_article {
      height: 36px;
      width: 52px;
      color: #fff;
      line-height: 36px;
      border-radius: 8px;
      font-size: 28px;
      position: fixed;
      z-index: 2;
      left: 50%;
      bottom: 7px;
      transform: translateX(-50%);
      background-color: #ff6e01;
    }
    .van-tabbar-item__text {
      display: flex;
      flex-direction: column;
      align-items: center;
      .zixun {
        display: block;
        margin-bottom: 3px;
        font-size: 22px;
      }
    }
  }
  //遮罩层
  .consulting {
    font-size: 14px;
    font-weight: bold;
    color: #0000;
    z-index: 100;
    .van-field__label {
      width: 44px;
    }

    .van-field__control {
      font-weight: 500;
      width: 194px;
      border: 1px solid #bfbfbf;
      border-radius: 5px;
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .block {
      width: 303px;
      border-radius: 8px;
      background-color: #fff;
      color: black;

      > div {
        // height: 20px;
        > div:nth-child(1) {
          .van-hairline {
            border-radius: 0 0 0 10px;
            padding: 0;

            height: 46px;

            .van-grid-item__text {
              color: #999999;
            }
          }
        }

        > div:nth-child(2) {
          .van-hairline {
            border-radius: 0 0 10px 0;
            padding: 0;

            .van-grid-item__text {
              color: #333333;
            }
          }

          [class*="van-hairline"]::after {
            border-right: none;
          }
        }
      }

      [class*="van-hairline"]::after {
        border-bottom: none;
      }

      .name-card {
        background-color: #ffff;
        border-bottom: 1px solid #f1f3f6;
        padding: 0 16px;

        p {
          padding: 0;
          margin: 0;
        }

        .name-info {
          display: flex;
          text-align: left;
          font-size: 14px;
          color: #333333;
          padding: 8px 0;
          // justify-content: space-between;
          img {
            height: 40px;
            width: 40px;
            border-radius: 20px;
          }

          .creater-info {
            margin-left: 8px;

            > p:nth-child(1) {
              font-weight: 700;
            }

            > p:nth-child(2) {
              font-size: 12px;
              color: #666666;
            }
          }
        }

        .synopsis {
          text-align: left;
          font-size: 12px;
          color: black;
        }
      }

      .info {
        padding: 0 10px;

        .van-cell::after {
          border: none;
        }

        .van-field__label {
          color: black;
        }

        [class*="van-hairline"]::after {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
